var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFarmaciaLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tvbpb9tgvb",
    width: "197.2%",
    height: "197.2%",
    x: "-48.6%",
    y: "-43.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.158387595 0 0 0 0 0.299784887 0 0 0 0 0.530485734 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "gdal5mpr8a",
    width: 36,
    height: 36,
    x: 0,
    y: 0,
    rx: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -300) translate(29 309)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2ex5zrunnc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gdal5mpr8a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#tvbpb9tgvb)",
    xlinkHref: "#gdal5mpr8a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#319795",
    xlinkHref: "#gdal5mpr8a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M17.517 24L17.517 19.088 21.517 19.088 21.517 17.68 17.517 17.68 17.517 14.176 22.365 14.176 22.365 12.704 15.693 12.704 15.693 24z",
    mask: "url(#2ex5zrunnc)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmaciaLogo);
export default __webpack_public_path__ + "static/media/Farmacia-logo.fd85328b10d50f5ae82265fc1c5a11a1.svg";
export { ForwardRef as ReactComponent };